/* global Third */
window.Opportunity = {

	editableSticky	: true,
	beforeDropStep	: null,
	beforeDropIndex	: null,
	callbacks		: {},
	BATCH_CREATE_THIRD_LIMIT: 150,

	loadAgendaTab : function(startTime, endTime, days, view, forceLocation){
		if($('#opp-fullcalendar table').length == 0) {
			setTimeout(function () {
				$('#calendar').fullCalendar('destroy');
				MyFacture.customForm();
				Agenda.initCalendar(startTime, endTime, days, view, forceLocation);
			}, 500);

		}
	},

	setStep: function (stepid, oid) {

		MyFacture.post('prospection_opportunity',
			{
				action: 'recordStep',
				oid: oid,
				stepid: stepid
			},
			function (data) {

				if (data.status === 'ok') {

					if ($('#opportunitiesListing').length > 0) {
						Listing.update('opportunitiesListing', true);
					} else {
						if ($('#pipelinesListing').length > 0) {
							Listing.update('pipelinesListing', true);
						} else {
							$("#step" + data.step.id).addClass('current');
							$(".opstep:not(#step" + data.step.id + ")").removeClass('current');
							$('.nbDayInCurrentStep').html(0);
						}
					}

					if (data.processAutomationStepEnter === 'Y') {
						Opportunity.askProcessAutomationStepEnter(oid);
					} else{
                        Utils.reload();
                    }

				} else if (data.status === 'failed' && data.message !== '') {
					MyWindow.alert(data.message, {type: "error"});
				}

			},
			'json'
		);
	},

	askProcessAutomationStepEnter: function (oid) {

		var options = {
			type	: 'warning',
			title	: Loc.g("Envoi automatique d’email"),
			noclose	: true,
			buttons	: [
				{
					text: Loc.g("Annuler"),
					click: function () {
                        $(this).dialog("close");
                        Utils.reload();
					}
				},
				{
					text: Loc.g("Envoyer l'email"),
					click: function () {
						$(this).dialog('close');
						Opportunity.processAutomationStepEnter(oid);
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Une action est configurée pour envoyer automatiquement un email lorsqu'une opportunité entre dans cette étape de pipeline. Que voulez-vous faire ?"), options);

	},

	processAutomationStepEnter: function (oid) {

		MyFacture.post(
			'prospection_opportunity',
			{
				action: 'processAutomationStepEnter',
				oid: oid
			},
			function (data) {
				if (data.status === 'ok') {
                    console.log('automation-process-ok');
                    Utils.reload();
				} else {
					console.log('automation-process-ko');
				}
			},
			'json'
		);

	},

	setStatus: function (status, oid) {
		MyFacture.post(
			'prospection_opportunity',
			{
				action	: 'recordStatus',
				oid		: oid,
				status	: status
			},
			function (data) {

				if (data.status === 'ok') {

					if ($('#opportunitiesListing').length > 0) {
						Listing.update('opportunitiesListing', true);
					} else if ($('#pipelinesListing').length > 0) {
						Listing.update('pipelinesListing', true);
					}  else {
						Utils.reload();
					}
				} else if (data.status === 'failed' && data.message !== '') {
					MyWindow.alert(data.message, {type: "error"});
				}
			},
			'json'
		);
	},

	initAddForm: function (fromDoc, edit) {

		edit = edit === undefined ? "N" : edit;

		$('input[name=po_linkedtype]').change(function () {

			if ($(this).val() === "newProspect") {

				$("#newProspectForm").slideDown('fast');
				MyFacture.customForm("#newProspectForm");
				Opportunity.clearContactToken();
				$('#contactsLinked').hide();

			} else {
				$("#newProspectForm:visible").slideUp('fast');
				Opportunity.clearContactToken();
				$('#contactsLinked').show();
			}
		});

		var context = "";
		if (fromDoc != undefined && fromDoc == 'Y') {
			context = 'document';
		}

		var options = {
			dataType	: "json",
			data		: {
				action	: 'record',
				context	: context
			},
			success		: function (data) {
				Opportunity.recordOpportunityCallback(data, edit);
			}
		};

		MyForm.prepare("opportunityForm", "prospection_opportunity&", options, true);

		$('#po_proba').val($("#po_stepid option:selected").attr('proba'));

		$('#po_proba').keyup(function () {
			$('#po_proba').unbind('keyup');
			$('#po_proba').addClass('editedManually');
		});

		$('.token-input-list').on('click', function () {
			var radio = $(this).prev().find('input:radio');
			if (radio.length > 0) {
				$('input:radio[name=po_linkedtype]:checked').prop('checked', false);
				radio.prop('checked', true);
				if (radio.val() === "newProspect") {
					$("#newProspectForm").slideDown('fast');
					Opportunity.clearContactToken();
					$('#contactsLinked').hide();
				} else {
					$("#newProspectForm:visible").slideUp('fast');
					Opportunity.clearContactToken();
					$('#contactsLinked').show();
				}
			}
			MyFacture.customForm();
		});

		MyFacture.customForm();
	},

	setEditedManualy: function (id) {
		$("#" + id).unbind('keyup');
		$("#" + id).addClass('editedManually');
	},

	setContactToken: function (item) {
		var more = item.id.replace('corporation_', 'thirdid_');
		$('#po_contacts').tokenInput("clear");
		$('#po_contacts').tokenInput("more", more);
	},

	clearContactToken: function () {
		$('#po_contacts').tokenInput("clear");
		$('#po_contacts').tokenInput("more", "");

	},

	processForm: function (data) {
		MyForm.processJson(data, "opportunityForm");
	},

	editOpportunity: function (id, context) {
		var options = {
			title: Loc.g("Modification d'une opportunité"),
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Enregistrer"),
					click: function () {
						$("#opportunityForm").submit();
					}
				}
			],
			width: 1200,
			callback: function () {
				Opportunity.prepareOpportunityForm(context);
			}
		};
		MyWindow.load('prospection_opportunity', {action: "editForm", oid: id}, options);
	},

	addOpportunity: function (id, prefilledThirdid, moreLinked) {

		prefilledThirdid = prefilledThirdid === undefined ? '' : prefilledThirdid;
		moreLinked = moreLinked === undefined ? {} : moreLinked;

		var options = {
			title		: Loc.g("Ajout d'une opportunité"),
			dialogClass	: "white",
			buttons		: [
				{
					text	: Loc.g("Annuler"),
					click	: function () {
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Enregistrer"),
					click	: function () {

						var buttons = $(this).parent().find('.ui-dialog-buttonpane');
						var register = buttons.find('button[type=button]').find('span.ui-button-text').first();
						var body = $('body');

						register.text(Loc.g('Chargement') + ' ...');
						register.attr('disabled', 'disabled');

						if (body.data('addFormDisabled') === undefined) {
							body.data('addFormDisabled', false);
						}

						if (!body.data('addFormDisabled')) {

							body.data('addFormDisabled', true);
							$("#opportunityForm").submit();

							setTimeout(function () {

								var buttons = $('#popupWindow').parent().find('.ui-dialog-buttonpane');
								var register = buttons.find('button[type=button]').find('span.ui-button-text').first();

								register.text(Loc.g('Enregistrer'));
								body.data('addFormDisabled', false);

							}, 2000);

						}
					}
				}
			],
			width	: 1200,
			callback: function () {

				Opportunity.callbacks.afterNewProspectShowing = function () {

					if (moreLinked.thirdEmail !== undefined && $('input[name=po_linkedtype]:checked').val() === 'newProspect') {
						$('#thirdcontact_email, #corp_email').val(moreLinked.thirdEmail);
					}

				};

				Opportunity.initAddForm("N", "N");

				// Used for creation from support ticket
				if (prefilledThirdid === 0 && moreLinked.thirdEmail !== undefined && moreLinked.thirdEmail !== '' && $("input#po_prospectid", "#thirdOrProspect").val() === '' && $("input#po_thirdid", "#thirdOrProspect").val() == '') {
					$('input[type="radio"][name="po_linkedtype"][value="newProspect"]', '#thirdOrProspect').prop("checked", true).click().change();
				}
				Qtip.init();
			}
		};

		MyWindow.load('prospection_opportunity', {action: "addForm", oid: id, thirdid: prefilledThirdid, moreLinked: moreLinked}, options);

	},

	linkOppToDoc: function (linkedtype, linkedid) {

		var options = {
			title: Loc.g("Lier une opportunité"),
			buttons: [
				{text: Loc.g("Annuler"), click: function () {
						$(this).dialog("close");
					}},
				{text: Loc.g("Lier"), click: function () {
						$("#opportunityLinkToDocForm").submit();
					}}
			],
			width: 800,
			callback: function () {
				Qtip.init();
				Opportunity.prepareLinkOppForm();
			}
		};

		var fileOpt = {action: "linkOppToDocForm", linkedtype: linkedtype, linkedid: linkedid};
		MyWindow.load("prospection_opportunity", fileOpt, options);

	},

	prepareLinkOppForm: function () {

		var formId = "opportunityLinkToDocForm";
		var options = {success: function (data) {
				Opportunity.recordLinkOppCallback(data);
			}, dataType: "json"};
		var params = {action: 'linkOppRecord'};
		MyForm.prepare(formId, "prospection_opportunity&" + $.param(params), options, true);
		MyFacture.initEvent("#opportunityLinkToDocForm");
	},

	recordLinkOppCallback: function (data) {
		MyWindow.close();
        var newDueDate = data.newDueDate;
        var oppsIds = data.oppsIds;
        var newAmount = data.newAmount;
        var redirectAfter = data.redirectAfter;
        var oppsToUpdate = data.oppsToUpdate;
        var canwriteopp = data.canwriteopp;
        if(oppsToUpdate == 'Y' && canwriteopp == 'Y'){
            DocFormv2.updateOppWithDocDataForm(newDueDate, oppsIds, newAmount, redirectAfter);
        }
	},

	unlinkOppToDoc: function (docLinkedElemId) {
		var options = {
			type: "warning",
			resizable: false,
			noclose: true,
			title: Loc.g("Confirmation"),
			buttons: [
				{text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{text: Loc.g("Délier"),
					click: function () {
						// action
						Opportunity.unlinkOppToDocRecord(docLinkedElemId);
						$(this).dialog("close");
					}
				},
			]
		};

		MyWindow.alert(Loc.g('Êtes-vous sûr de vouloir délier l‘opportunité du document ?'), options);
	},

	unlinkOppToDocRecord: function (docLinkedElemId) {

		var datas = {
			action: "unlinkOppToDoc",
			docLinkedElemId: docLinkedElemId,
		};

		MyFacture.post("prospection_opportunity", datas, function (data) {
			if (data.status === 'ok') {
				$('.oppLinkedToDoc #' + docLinkedElemId + '').remove();
			}
		}, "json");
	},

	switchAddForm: function (element) {
		var $thirdPart = $('#thirdOrProspect');
		var checked = $('input[type="radio"]:checked', $thirdPart).val();
		var $prospectID = $('#po_prospectid', $thirdPart);
		var $thirdID = $('#po_thirdid', $thirdPart);

		// Reset token inputs
		$prospectID.tokenInput("clear");
		$prospectID.tokenInput("more", "");

		$thirdID.tokenInput("clear");
		$thirdID.tokenInput("more", "");

		switch (checked) {

			case 'newProspect':

				Third.loadPieceForForm('newProspectPop', 'prospect', 'opportunity', {
					success: Opportunity.callbacks.afterNewProspectShowing
				});

				break;

			default:

				var $newProspectPop = $('#newProspectPop', $thirdPart);

				if ($newProspectPop.is(':visible')) {
					$newProspectPop.slideUp(200);
				}

				break;

		}

	},

	addGroupedOpportunity: function (rowSelection) {
		if (rowSelection.length > Opportunity.BATCH_CREATE_THIRD_LIMIT) {
			MyWindow.alert(Loc.g(`Impossible de créer des opportunités en masse pour plus de ${Opportunity.BATCH_CREATE_THIRD_LIMIT} clients ou prospects.`), { type: 'error' });
			return;
		}

		var options = {
			title: Loc.g("Ajout d'opportunités en masse"),
			buttons: [
				{text: Loc.g("Annuler"), click: function () {
						$(this).dialog("close");
					}},
				{text: Loc.g("Enregistrer"), click: function () {
						$("#opportunityFormGroup").submit();
					}}
			],
			width: 900,
			callback: function () {
				Opportunity.prepareGroupeOpportunityForm();
			}
		};
		MyWindow.load('prospection_opportunity', {action: "addFormGroup", thirds: rowSelection}, options);
	},

	addOpportunityBeforRecord: function (thirdId, edit) {

		var edit = edit === "undefined" ? "N" : edit;

		// get document data for completing opportunitty form
		var datas = {
			dueDate: $("#expireDate").val(),
			name: $("input#subject").val(),
			potential: $("#totalDiscount_step:visible .tamount .total").length > 0 ? $("#totalDiscount_step .tamount .total").html() : $("#totalTaxesFree .tamount .total").html()
		};

		var options = {
			title: Loc.g("Ajout d'une opportunité"),
			buttons: [
				{text: Loc.g("Annuler"), click: function () {
						$(this).dialog("close");
					}},
				{text: Loc.g("Enregistrer"), click: function () {
						$("#opportunityForm").submit();
					}}
			],
			width: 1200,
			callback: function () {
				Opportunity.initAddForm("Y", edit);
                $("#opportunityForm").append("<input type='hidden' name='processAutomation' value=false />");
			}
		};
		MyWindow.load('prospection_opportunity', {action: "addForm", thirdid: thirdId, datas: datas}, options);
	},

	prepareOpportunityThirdForm: function (oid) {
		var options = {
			data: {
				action: 'thirdRecord',
				oid: oid
			},
			success: function (data) {
				Opportunity.recordOpportunityThirdCallback(data);
			},
			dataType: "json"
		};

		MyForm.prepare("opportunityThirdForm", "prospection_opportunity", options, true);
		MyFacture.customForm();
		Qtip.init();
	},

	prepareOpportunityForm: function (context) {
		var options = {
			data: {
				action: 'record',
				context: context,
			},
			success: function (data) {
				Opportunity.recordOpportunityCallback(data);
			},
			dataType: "json"
		};

		MyForm.prepare("opportunityForm", "prospection_opportunity", options, true);
		MyFacture.customForm();
		Qtip.init();
	},

	prepareGroupeOpportunityForm: function () {

		var options = {success: function (data) {
				Opportunity.recordGroupeOpportunityCallback(data);
			}, dataType: "json"};
		var params = {'action': 'recordGroup'};
		MyForm.prepare("opportunityFormGroup", "prospection_opportunity&" + $.param(params), options, true);
		MyFacture.customForm();
	},

	recordOpportunityThirdCallback: function (data) {
		var isOk = MyForm.processJson(data, "opportunityForm");

		if (isOk) {
			MyWindow.close();
			Utils.reload();
		}
	},

	recordOpportunityCallback: function (data, edit) {
		var isOk = MyForm.processJson(data, "opportunityForm");

		if (isOk) {
			if (data.context == 'document') {
				$("#docForm").append("<input type='hidden' name='opportunity_id' value='" + data.oppId + "' />");
				if (edit === "Y") {
					DocFormv2.record('recordOppAndEdit');
				} else {
					DocFormv2.record('recordOpp');
				}
			} else {
				switch (data.context) {
					case 'pipeline':
						Utils.reload();
						break;
					default :
						if (edit === "Y") {
							Utils.reload();
						}
						break;
				}
			}
		} else {
			if (data.form.fields.length === 1 && data.form.fields[0].fieldId === "checkIdentExist" && $("#checkDocIdent").val() === "Y") {
				var options = {
					type: 'warning',
					title: Loc.g("Identifiant"),
					noclose: true,
					closeOnEscape: function () {
						$(this).dialog("close");
					},
					width: 720,
					buttons: [
						{
							text: Loc.g("Enregistrer quand même l'opportunité"),
                            'class' : 'btn btn-primary',
							click: function () {
								$("#checkDocIdent").val("N");
								$("#opportunityForm").submit();
							}
						},
						{
							text: Loc.g("Modifier"),
                            'class' : 'btn btn-primary',
							click: function () {
								$("#po_ident").focus();
								$(this).dialog("close");
							}
						},
						{
							text: Loc.g("Suivre la numérotation et enregistrer"),
							'class' : 'btn btn-primary',
							click: function () {
								$("#po_ident").val(data.newIdent);
								$("#opportunityForm").submit();
							}
						}
					]
				};

				MyWindow.alert(Loc.g('Vous avez saisi un numéro d\'opportunité existant. Souhaitez vous le modifier ?'), options);
			}

		}

	},

	recordGroupeOpportunityCallback: function (data) {
		MyForm.processJson(data, "opportunityFormGroup");
		if ("ok" === data.form.status) {
			Utils.reload();
		} else {

			$("#prospctList li.error").removeClass("error");

			for (var i in data.form.fields) {

				var id = data.form.fields[i].fieldId.replace("po_opp-corp", "").split("-")[0];

				if (!$("#prospect_" + id).hasClass("error")) {
					$("#prospect_" + id).addClass("error");
				}

			}

			if (data.form.msg !== '') {
				MyWindow.alert(data.form.msg, {type: 'error'});
			}
		}
	},

	massAssignStaffForm: function (oppids) {
		var options = {
			title: Loc.g("Attacher des collaborateurs aux éléments sélectionnés"),
			width: 500,
			buttons: [
				{text: Loc.g("Annuler"), click: function () {
						$(this).dialog("close");
					}},
				{text: Loc.g("Enregistrer"), click: function () {
						$("#massAssignStaffForm").submit();
						$(this).dialog("close");
					}}
			],
			callback: function () {
				Opportunity.prepareMassAssignStaffForm('recordMassAssignStaffForm', 'massAssignStaffForm');
			}
		};

		var params = {
			action: "massAssignStaffForm",
			oppids: oppids
		};

		MyWindow.load("prospection_opportunity&action=massAssignStaffForm", params, options);
	},

	prepareMassAssignStaffForm: function (action, formid) {
		MyFacture.customForm();

		var options = {
			success: function (data) {
				var formIsOk = MyForm.processJson(data, "groupForm");
				if (formIsOk) {
					var opt = {
						title: Loc.g('Collaborateurs rattachés'),
						type: 'confirm',
						buttons: [
							{
								text: Loc.g("Ok"),
								click: function () {
									$(this).dialog("close");
								}
							}
						],
					};
					MyWindow.alert(Loc.g("Collaborateurs rattachés aux opportunités"), opt);
                    Listing.update('opportunitiesListing');
                    Utils.reload();
				}
			},
			dataType: "json"
		};

		MyForm.prepare(formid, "prospection_opportunity&" + $.param({action: action}), options, true);
	},

	editSticky: function (oid) {
		if (Opportunity.editableSticky) {
			var reg = /<br\s*[\/]?>/gi;
			var height = ($('.stickyContent').height() < 25 ? 25 : $('.stickyContent').height());
			var stickyContent = $('.stickyContent').html().replace(reg, "");
			$('.stickyContent').html('<form>'
					+ '<input type="hidden" name="oid" value="' + oid + '" />'
					+ '<textarea name="stickyContent" style="width:100%;height:' + height + 'px">' + stickyContent + '</textarea>'
					+ '<br /><input type="button" value="ok" onclick="Opportunity.recordSticky();" class="fright" style="border-radius: 2px;font-weight: bold;cursor: pointer;border: 1px solid #CECECE;color: #E0BEBEE;background: white;" /></form>');
			Opportunity.editableSticky = false;
		}
	},

	recordSticky: function () {
		var oid = $('input[name=oid]').val();
		var stickyContent = $('.stickyContent textarea[name=stickyContent]').val();

		MyFacture.post("prospection_opportunity", {'action': "recordSticky", 'oid': oid, 'stickyNote': stickyContent}, function (data) {
			Opportunity.recordStickyCallback(data);
		}, "json");
		$('.stickyContent').html(stickyContent);
	},

	recordStickyCallback: function (data) {
		if (data.err_code === 0) {
			if (data.stickyNote !== '') {
				$('.stickyNote a').html(Loc.g('Editer'));
			} else {
				$('.stickyNote a').html(Loc.g('Ajouter'));
			}
			Opportunity.editableSticky = true;
			$('.stickyContent').html(data.stickyNote);
		} else {
			MyWindow.alert(data.err_msg, {type: 'error'});
		}
	},

	setProba: function (sourceId, targetId) {

		var source = typeof (sourceId) === "undefined" ? "#po_stepid" : "#" + sourceId;
		var target = typeof (targetId) === "undefined" ? "#po_proba" : "#" + targetId;

		var proba = $(source + ' option:selected').attr('proba');
		if (proba !== '') {
			$(target + ':not(.editedManually)').val(proba);
		}
	},

	buildPagenum: function (pagenum, nbpage) {},

	confirmDeletion: function (oid, context) {
		var options = {
            dialogClass	: "white",
			resizable	: false,
			noclose		: true,
			type		: "warning",
			title		: Loc.g("Suppression d'une opportunité"),
			buttons		: [
				{
					text	: Loc.g("Annuler"),
					click	: function () {
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Valider"),
					click	: function () {
						Opportunity.deleteIt(oid, context);
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Valider pour supprimer l'opportunité.<br/><br/>Attention : Les tâches liées à l'opportunité seront également supprimées."), options);
	},

	deleteIt: function (oid, context) {
		$.ajax({
			type: "POST",
			url: MyFacture.buildUrl('prospection_opportunity'),
			data: {'action': "delete", 'oid': oid},
			success: function (data) {
				if(context === 'pipeline') {
					EventBus.$emit('opportunity:delete');
				}
				else if(context === 'opportunity_light_listing') {
					window.sellsyapp.$events.trigger('listing:refresh');
				}
				else {
					Utils.relocate('/prospection/opportunities');
				}
			},
			error: function(error){
				Push.error(Loc.g("Une erreur est survenue lors de la suppression de l'opportunité"))
			},
			dataType: 'json'
		});

		return true;
	},

	linkTo: function (oid) {

		var options = {
            title: Loc.g("Lier un document à l'opportunité"),
            dialogClass: "white",
			buttons: [
				{text: Loc.g("Annuler"), click: function () {
						$(this).dialog("close");
					}},
				{text: Loc.g("Enregistrer"), click: function () {
						$("#opportunityLink").submit();
					}}
			],
			callback: function () {
				Opportunity.prepareLinkForm();
			}
		};

		var fileOpt = {action: "linkForm", oid: oid};
		MyWindow.load("prospection_opportunity", fileOpt, options);

	},

	prepareLinkForm: function () {

		var formId = "opportunityLink";
		var options = {success: function (data) {
				Opportunity.recordLinkCallback(data);
			}, dataType: "json"};
		var params = {action: 'linkRecord'};
		MyForm.prepare(formId, "prospection_opportunity&" + $.param(params), options, true);
		MyFacture.initEvent("#opportunityLink");

		$('.doctypeLinked').change(function () {
			var show = $(this).val();
			$('.autocompletedoc').hide();
			$('#autocomplete_' + show).show();
		});
	},

	recordLinkCallback: function (data) {
		if (data.status === "error") {
			MyWindow.close();
		} else {
            if(data.oppsIds != '') {
                var newDueDate 	= data.newDueDate;
                var oppsIds 	= data.oppsIds;
                var newAmount 	= data.newAmount;
                var canwriteopp = data.canwriteopp;
                var redirectAfter = data.redirectAfter;
                if (canwriteopp == 'Y') {
                    DocFormv2.updateOppWithDocDataForm(newDueDate, oppsIds, newAmount, redirectAfter);
                } else {
                    Utils.reload();
                }
            } else{
                Utils.reload();
            }
		}
	},

	unlink: function (dlid) {

		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Délier le document"),
			buttons		: [
				{
					text	: Loc.g("Non"),
					click	: function () {
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Oui"),
					click	: function () {
						var datas = {
							action	: "linkDelete",
							dlid	: dlid
						};
						MyFacture.post("prospection_opportunity", datas, function (data) {
							Utils.reload();
						}, "json");
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Délier le document de l'opportunité ?"), options);
	},

	eventCallback: function (data) {
		Listing.update($('#listingname').val());
	},

	taskCallback: function (data) {

		var opp = $('#opp_' + data.event.relatedid);

		if ($('#pipelinesListing').length > 0) {

			if (data.event.state === 'late') {
				opp.find('.status').find('i').attr('class', 'fa fa-tasks warning-50');
				opp.find('.status').find('a').attr('class', 'warning-50').attr('href', "#").removeAttr('onClick');
				opp.find('.status').find('span').html(Loc.g('1 tâche(s) en retard'));
			} else {
				opp.find('.status').find('i').attr('class', 'fa fa-tasks green');
				opp.find('.status').find('a').attr('class', 'green').attr('href', "#").removeAttr('onClick');
				opp.find('.status').find('span').html(Loc.g('1 tâche(s) en cours'));
			}

		} else {

			if (data.event.state === 'late') {
				opp.find('.status img').removeAttr('width').attr('src', '/ressources/logged/img/prospection/status_late.png').attr('tips', Loc.g('1 tâche(s) en retard'));
			} else {
				opp.find('.status img').removeAttr('width').attr('src', '/ressources/logged/img/prospection/status_ok.png').attr('tips', Loc.g('1 tâche(s) en cours'));
			}

		}

		Listing.update('opportunitiesListing', true);
		Qtip.init();
	},

	taskCallback2: function (data) {
		Utils.relocate('/?_f=prospection_opportunity&action=overview&oid=' + data.event.relatedid);

		if (data.event.state === 'late') {
			$('#opp_status img').addClass('late');
			$('#opp_status img').removeClass('ok');
			$('#opp_status img').removeAttr('width').attr('src', '/ressources/logged/img/prospection/status_late.png').attr('tips', Loc.g('1 tâche(s) en retard'));
		} else if (!$('#opp_status img').hasClass('late')) {
			$('#opp_status img').addClass('ok');
			$('#opp_status img').removeAttr('width').attr('src', '/ressources/logged/img/prospection/status_ok.png').attr('tips', Loc.g('1 tâche(s) en cours'));
		}
		Qtip.init();
	},

	duplicateOpportunity: function (id) {
        let originalIdPrefix    = `po_opp-corp${id}-`;
        let opportunity = {
            source:     $(`#${originalIdPrefix}source`).val(),
            dueDate:    $(`#${originalIdPrefix}dueDate`).val(),
            name:       $(`#${originalIdPrefix}name`).val(),
            potential:  $(`#${originalIdPrefix}potential`).val(),
            funnel:     $(`#${originalIdPrefix}funnel`).val(),
            stepid:     $(`#${originalIdPrefix}stepid`).val(),
            proba:      $(`#${originalIdPrefix}proba`).val(),
            staff:      $(`#${originalIdPrefix}staff`).tokenInput("get")
        };

		var optionsFunnel	= $(`#${originalIdPrefix}funnel`).html();
        var optionsSteps	= $(`#${originalIdPrefix}stepid`).html();

		$("input.ui-state-error").removeClass("ui-state-error");

		$("#opportunityFormGroup #contentPan .panForm").each(function (i, elem) {

			let oppId = $(elem).find(".corpid").val();
            let idPrefix = `po_opp-corp${oppId}-`;

			$("#prospect_" + oppId).removeClass("error");

			if (id != oppId) {
                $(`#${idPrefix}source`).val(opportunity.source);
                $(`#${idPrefix}dueDate`).val(opportunity.dueDate);
                $(`#${idPrefix}name`).val(opportunity.name);
                $(`#${idPrefix}potential`).val(opportunity.potential);
                $(`#${idPrefix}proba`).val(opportunity.proba);

				// Vidage du funnel et du stepid
				$(`#${idPrefix}funnel`).parent(".form-input").html('<select name="po_opp[' + oppId + '][funnel]" id="po_opp-corp' + oppId + '-funnel" onchange="Prospection.getStepsForFunnel(\'po_opp-corp' + oppId + '-funnel\', \'po_opp-corp' + oppId + '-stepid\');">' + optionsFunnel + '</select>');
                $(`#${idPrefix}funnel`).val(opportunity.funnel);

                $(`#${idPrefix}stepid`).parent(".form-input").html('<select name="po_opp[' + oppId + '][stepid]" id="po_opp-corp' + oppId + '-stepid">' + optionsSteps + '</select>');
                if (undefined !== $(`#${originalIdPrefix}stepid`).attr('onChange')) {
                    $(`#${idPrefix}stepid`).attr('onChange', `Opportunity.setProba(\'${idPrefix}stepid\', \'${idPrefix}proba\');`)
                }
                $(`#${idPrefix}stepid`).val(opportunity.stepid);

                opportunity.staff.forEach((staff) => {
                    if ((typeof ($(`#${idPrefix}staff`).data("tokenInputObject")) !== "object")) {
                        TokenInput.autoContactListing($(`#${idPrefix}staff`), 'staff', '5', true, '');
                    }
                    $(`#${idPrefix}staff`).tokenInput("add", {...staff});
                })

				MyFacture.customForm();

			}
		});


		Opportunity.endDuplication(id);

	},

	startDuplication: function (id) {

		$("#duplicateButton-" + id).fadeOut(200, function () {
			$("#loaderDuplicate-" + id).fadeIn(200, function () {
				Opportunity.duplicateOpportunity(id);
			});
		});


	},

	endDuplication: function (id) {

		$("#loaderDuplicate-" + id).fadeOut(200);
		$("#duplicateOk-" + id).delay(200).fadeIn(300);
		$("#duplicateOk-" + id).delay(3000).fadeOut(300);
		$("#duplicateButton-" + id).delay(4000).fadeIn(300);


	},

	oppCreated: function (oppId) {

		var options = {
			type: 'confirm',
			title: Loc.g("Opportunité créé"),
			buttons: [
				{
					text: Loc.g("Fermer"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Voir l'opportunité"),
					click: function () {
						Utils.relocate('/?_f=prospection_opportunity&action=overview&oid=' + oppId)
					}
				}
			]
		};

		MyWindow.alert(Loc.g("L‘opportunité liée à ce devis a été créé"), options);
	},

	deleteOpportunities: function (rowSelection) {

		var msg = Loc.g("Vous allez supprimer ces opportunités, cette action est irreversible.");

		var options = {
			type: "warning",
			resizable: false,
			noclose: true,
			width: 600,
			title: Loc.g("Supprimer les opportunités"),
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Supprimer les opportunités"),
					click: function () {
						MyFacture.post('prospection_opportunity', {action: "deleteOpportunites", rowSelection: rowSelection}, function (data) {
							Utils.reload();
						}, "json");
					}
				}
			]
		};

		MyWindow.alert(msg, options);


	},

	forceData: function (data, value) {
		$('#pipelinesFilterForm').find('#pipelinesListing_filter_' + data).val(value);
	},

	opportunityThirdTokenUpdate: function (element) {
		var value = $(element).val();
		var more = '';

		if (value === '') {
			more = '';
		} else {
			var splited = value.split('_');
			var id = splited[1];
			more = 'thirdid_' + id;
		}

		$('#po_contacts').tokenInput('clear');
		$('#po_contacts').tokenInput('more', more);
	},

	pipelineSelectChange: function (selectPipelineId, selectStepsId) {

		var selectpipeline = typeof (selectPipelineId) === "undefined" ? "#po_funnelid" : '#' + selectPipelineId;
		var selectsteps = typeof (selectStepsId) === "undefined" ? "#po_stepid" : '#' + selectStepsId;

		var selectPipelineElement = $(selectpipeline);
		var selectStepsElement = $(selectsteps);


		if (selectPipelineElement.val() == '') {
			selectStepsElement.empty();
			selectStepsElement.hide();
		} else {
			selectStepsElement.show();

			options = {
				optionAll: true,
				optionAllLabel: Loc.g('Toutes les étapes')
			};

			Prospection.getStepsForFunnel(selectPipelineId, selectStepsId, options);
		}

	},

	checkStepHasAutomationOnStepEnter: function (funnelid, stepid) {

		var funnelid = typeof (funnelid) === "undefined" ? "#po_funnelid" : "#" + funnelid;
		var stepid = typeof (stepid) === "undefined" ? "#po_stepid" : "#" + stepid;

		var funnel = $(funnelid);
		var step = $(stepid);

		if (funnel.length > 0 && step.length > 0) {

			var stepHasAutomationOnStepEnter = Automation.stepHasAutomationOnStepEnter(funnel.val(), step.val());
			$('.stepHasAutomationOnStepEnter').toggleClass('hidden', stepHasAutomationOnStepEnter !== 'Y');

		}

	},

	moveOpportunities: function (rowSelection) {

		var options = {
			title: Loc.g("Déplacement des opportunités"),
			width: 500,
			buttons: [
				{text: Loc.g("Annuler"), click: function () {
						$(this).dialog("close");
					}},
				{text: Loc.g("Enregistrer"), click: function () {
						$("#moveOpportunitiesForm").submit();
						$(this).dialog("close");
					}}
			],
			callback: function () {
				Opportunity.prepareMoveOpportunitesForm('recordMoveOpportunitiesForm', 'moveOpportunitiesForm');
			}
		};

		var params = {
			action: "moveOpportunitiesForm",
			oppids: rowSelection
		};

		MyWindow.load("prospection_listing", params, options);

	},

	prepareMoveOpportunitesForm: function (action, formid) {

		MyFacture.customForm();
		Opportunity.checkStepHasAutomationOnStepEnter('moveopps_funnelid', 'moveopps_stepid');

		var options = {
			success: function (data) {
				var formIsOk = MyForm.processJson(data, "groupForm");
				if (formIsOk) {
					var opt = {
						title: Loc.g('Opportunités ont bien été déplacées'),
						type: 'confirm',
						buttons: [
							{text: Loc.g("Ok"),
								click: function () {
									$(this).dialog("close");
								}}
						],
					};

					MyWindow.alert(Loc.g("Opportunités déplacées"), opt);
					Utils.reload();
				}
			},
			dataType: "json"
		};

		MyForm.prepare(formid, "prospection_listing&" + $.param({action: action}), options, true);
	},

	updateStatusOpp: function (rowSelection) {

		var options = {
			title: Loc.g("Modification statut"),
			width: 500,
			buttons: [
				{text: Loc.g("Annuler"), click: function () {
						$(this).dialog("close");
					}},
				{text: Loc.g("Enregistrer"), click: function () {
						$("#updateStatusOppForm").submit();
						$(this).dialog("close");
					}}
			],
			callback: function () {
				Opportunity.prepareUpdateStatusOppForm('recordUpdateStatusOppForm', 'updateStatusOppForm');
			}
		};

		var params = {
			action: "updateStatusOppForm",
			oppids: rowSelection
		};

		MyWindow.load("prospection_listing", params, options);

	},

	prepareUpdateStatusOppForm: function (action, formid) {

		MyFacture.customForm();

		var options = {
			success: function (data) {
				var formIsOk = MyForm.processJson(data, "groupForm");
				if (formIsOk) {
					var opt = {
						title: Loc.g('Opportunités bien modifiées'),
						type: 'confirm',
						buttons: [
							{text: Loc.g("Ok"),
								click: function () {
									$(this).dialog("close");
								}}
						],
					};

					MyWindow.alert(Loc.g("Les opportunités ont bien été modifiées."), opt);
					Utils.reload();
				}
			},
			dataType: "json"
		};

		MyForm.prepare(formid, "prospection_listing&" + $.param({action: action}), options, true);
	},

	updateDueDateOpp: function (rowSelection) {

		var options = {
			title: Loc.g("Modification des dates d'échéance"),
			width: 500,
			buttons: [
				{text: Loc.g("Annuler"), click: function () {
						$(this).dialog("close");
					}},
				{text: Loc.g("Enregistrer"), click: function () {
						$("#updateDueDateOppForm").submit();
						$(this).dialog("close");
					}}
			],
			callback: function () {
				Opportunity.prepareUpdateDueDateOppForm('recordUpdateDueDateOppForm', 'updateDueDateOppForm');
			}
		};

		var params = {
			action: "updateDueDateOppForm",
			oppids: rowSelection
		};

		MyWindow.load("prospection_listing", params, options);

	},

	prepareUpdateDueDateOppForm: function (action, formid) {

		MyFacture.customForm();

		var options = {
			success: function (data) {
				var formIsOk = MyForm.processJson(data, "groupForm");
				if (formIsOk) {
					var opt = {
						title: Loc.g('Opportunités bien modifiées'),
						type: 'confirm',
						buttons: [
							{text: Loc.g("Ok"),
								click: function () {
									$(this).dialog("close");
								}}
						],
					};

					MyWindow.alert(Loc.g("Les opportunités ont bien été modifiées."), opt);
					Utils.reload();
				}
			},
			dataType: "json"
		};

		MyForm.prepare(formid, "prospection_listing&" + $.param({action: action}), options, true);
	},

    updateSourceOpp : function(rowSelection){

        var options = {
            title	: Loc.g("Modification des sources"),
            width 	: 500,
            buttons	: [
                {text : Loc.g("Annuler"), click : function(){
                    $(this).dialog("close");
                }},
                {text : Loc.g("Enregistrer"), click : function(){
                    $("#updateSourceOppForm").submit();
                }}
            ],
            callback : function(){
                Opportunity.prepareUpdateSourceOppForm('recordUpdateSourceOppForm', 'updateSourceOppForm');

            }
        };

        var params = {
            action:"updateSourceOppForm",
            oppids: rowSelection
        };

        MyWindow.load("prospection_listing", params, options);

    },

    prepareUpdateSourceOppForm: function(action, formid){


        MyFacture.customForm();

        var options = {
            success: function (data) {
                MyWindow.close();
                var formIsOk = MyForm.processJson(data, "groupForm");
                if (formIsOk) {
                    var opt = {
                        title	: Loc.g('Opportunités bien modifiées'),
                        type	: 'confirm',
                        buttons	: [
                            {text: Loc.g("Ok"),
                                click: function () {
                                    $(this).dialog("close");
                                    Utils.reload();
                                }}
                        ],
                    };

                    MyWindow.alert(Loc.g("Les opportunités ont bien été modifiées."), opt);
                }
            },
            dataType: "json"
        };

        MyForm.prepare(formid, "prospection_listing&" + $.param({action: action}), options, true);
    },

	updateDefaultDocument: function (oid, docleid, elem) {

		MyFacture.post('prospection_opportunity',
				{action: 'updateDefaultDocument', oid: oid, docleid: docleid},
				function (data) {
					if (data.status === 'ok') {
						$('#content_docsLinked table td .updateMainDoc').each(function () {
							if ($(this).hasClass('icon-star-full')) {
								$(this).removeClass('icon-star-full').addClass('icon-star');
							}
						});
						elem.removeClass('icon-star').addClass('icon-star-full');
					} else if (data.status === 'ko' && data.message !== '') {
						MyWindow.alert(data.message, {type: "error"});
					}

				},
				'json');
	},

	toggleCard: function (el) {
		$(el).closest('.oppBlock').find('.oppMoreDetails').slideToggle();
		$(el).toggleClass("icon-more icon-less")
	},

	changeDisplayMode: function (el) {
		Listing.loader('show');

		var displayMode = $(el).data("display-mode");
		$(el).parent().children().removeClass("semibold bb-2-blue");
		$(el).addClass("semibold bb-2-blue");

		// $("#" + $("#pipelinesListing_filterFormName").val()).submit();
		$("#pipelinesListing_filter_displayPipeMode").val(displayMode);
		$("#pipelinesFilterForm").submit();
	},

	updatePipelineTopSelector : function () {
		var selectedPipe = $("#pipelinesListing_filter_funnelid").val();
		$("#pipeline-selector").val(selectedPipe);
    },

	focusPrevRadio: function (el) {
		$(el).parent().find("input[type=radio]").click();
	},
};
